/**
 * Publish/subscribe model on cart status
 *
 * Injections:
 *   -> $rootScope: to emit an event to listeners on the rootScope
 */

export function CartStatusChannel($rootScope, CART_EVENTS) {
    'ngInject';
    return {
        configuredCart,
        onConfiguredCart,
        changedCart,
        onChangedCart,
        editedCart,
        onEditedCart
    };

    ///------------------------------------

    function configuredCart(fulfillmentDate) {
        $rootScope.$emit(CART_EVENTS.CART_CONFIGURED, fulfillmentDate);
    }

    function onConfiguredCart(scope, callback) {
        var callbackCleanup = $rootScope.$on(CART_EVENTS.CART_CONFIGURED, function(event, fulfillmentDate) {
            callback(fulfillmentDate);
        });

        scope.$on('$destroy', function() {
            callbackCleanup();
        });
    }

    function changedCart() {
        $rootScope.$emit(CART_EVENTS.CART_CHANGED);
    }

    function onChangedCart(scope, callback) {
        var callbackCleanup = $rootScope.$on(CART_EVENTS.CART_CHANGED, function() {
            callback();
        });

        scope.$on('$destroy', function() {
            callbackCleanup();
        });
    }

    function editedCart(diningOptionBehavior, fulfillmentType, fulfillmentDate) {
        $rootScope.$emit(CART_EVENTS.CART_EDITED, diningOptionBehavior, fulfillmentType, fulfillmentDate);
    }

    function onEditedCart(scope, callback) {
        var callbackCleanup = $rootScope.$on(CART_EVENTS.CART_EDITED, function(event, diningOptionBehavior, fulfillmentType, fulfillmentDate) {
            callback(diningOptionBehavior, fulfillmentType, fulfillmentDate);
        });

        scope.$on('$destroy', function() {
            callbackCleanup();
        });
    }
}
